const PropTypes = require('prop-types');
const React = require('react');
const Tooltip = require('components/tooltip.jsx');
const APIRequest = require('components/api_request.js');

class BulkCuratedSetItem extends React.Component {
  static get propTypes() {
    return {
      curatedSet: PropTypes.object.isRequired,
    };
  }

  constructor() {
    super();

    this.state = {
      addingListings: false,
      addedListings: false,
      removingListings: false,
      removedListings: false,
      error: false,
    };

    this.handleAddListings = this.handleAddListings.bind(this);
    this.handleRemoveListings = this.handleRemoveListings.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  get curatedSet() {
    return this.props.curatedSet;
  }

  get canAdd() {
    return !this.curatedSet.unavailable_to_add_reason;
  }

  handleAddListings(e) {
    e.preventDefault();

    this.setState({ addingListings: true });

    APIRequest.V3.post(
      `/my/selling/curated_sets/${this.curatedSet.id}/add_listings${window.location.search}`
    ).then(() => {
      this.setState({
        addingListings: false,
        addedListings: true,
      });
    }).fail(this.handleError);
  }

  handleRemoveListings(e) {
    e.preventDefault();

    this.setState({ removingListings: true });

    APIRequest.V3.post(
      `/my/selling/curated_sets/${this.curatedSet.id}/remove_listings${window.location.search}`
    ).then(() => {
      this.setState({
        removingListings: false,
        removedListings: true,
      });
    }).fail(this.handleError);
  }

  handleError() {
    this.setState({
      error: true,
      addingListings: false,
      removingListings: false,
    });
  }

  renderLabelTooltip() {
    if (!this.curatedSet.label_tooltip) { return null; }

    return (
      <Tooltip
        title={this.curatedSet.label_tooltip}
        className="ml-half"
      />
    );
  }

  renderTitleLabel() {
    if (!this.curatedSet.label) { return null; }

    return (
      <div className="font-tiny strong">
        <span className="color-orange">
          {this.curatedSet.label}
          {this.renderLabelTooltip()}
        </span>
      </div>
    );
  }

  renderTitle() {
    return (
      <a
        href={this.curatedSet._links.self.href}
        className="strong"
        target="_blank"
      >
        {this.curatedSet.name}
      </a>
    );
  }

  renderAdditionalInformation() {
    if (!this.curatedSet.additional_information) { return null; }

    return (
      <div>
        {this.curatedSet.additional_information}
      </div>
    );
  }

  renderAddButton() {
    if (!this.canAdd) {
      return (
        <span
          className="btn btn-tiny btn-orange btn-disabled inline-block mr-space"
        >
          {I18n.t('js.dashboard.selling.bulkSale.addDisabled')}
        </span>
      );
    }

    const count = this.curatedSet.add_count;
    if (count < 1) { return null; }
    return (
      <a
        href="#"
        onClick={this.handleAddListings}
        className="btn btn-tiny btn-orange mr-space"
        data-add-button
      >
        {this.renderI18nCount('addListings', count)}
      </a>
    );
  }

  renderRemoveButton() {
    const count = this.curatedSet.remove_count;
    if (count < 1) { return null; }

    return (
      <a
        href="#"
        onClick={this.handleRemoveListings}
        className="btn btn-tiny mr-space"
        data-remove-button
      >
        {this.renderI18nCount('removeListings', count)}
      </a>
    );
  }

  renderI18nCount(i18nKey, count) {
    return I18n.t(`js.dashboard.selling.bulkSale.${i18nKey}`, {
      formattedCount: I18n.toNumber(count),
      count,
    });
  }

  renderSuccess(i18nKey, count) {
    return (
      <div className="color-green icon-l-check">
        {this.renderI18nCount(i18nKey, count)}
      </div>
    );
  }

  renderUnavailableMessage() {
    if (this.canAdd) { return null; }

    return (
      <p className="alert alert-small alert-info">
        {this.curatedSet.unavailable_to_add_reason}
      </p>
    );
  }

  renderActions() {
    if (this.state.addedListings) {
      return this.renderSuccess('listingsAdded', this.curatedSet.add_count);
    } else if (this.state.removedListings) {
      return this.renderSuccess('listingsRemoved', this.curatedSet.remove_count);
    } else if (this.state.addingListings || this.state.removingListings) {
      return I18n.t('js.wait');
    } else if (this.state.error) {
      return (
        <div className="alert alert-error alert-small">
          {I18n.t('js.dashboard.selling.bulkSale.error')}
        </div>
      );
    }

    return (
      <div>
        {this.renderAddButton()}
        {this.renderRemoveButton()}
      </div>
    );
  }

  render() {
    return (
      <div className="bulk-sale-list__item">
        <div className="sale-top-content">
          <div className="dark-links">
            {this.renderTitleLabel()}
            {this.renderTitle()}
          </div>
          <div className="extratight-line-height size-90 mb-half">
            {this.renderAdditionalInformation()}
            {this.curatedSet.summary}
          </div>
          {this.renderUnavailableMessage()}
          <div className="mb-half">
            {this.renderActions()}
          </div>
        </div>
      </div>
    );
  }
}

module.exports = BulkCuratedSetItem;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/listings_manager/sales/bulk_curated_set_item.jsx